import { createContext, useContext, useRef, useState } from "react";

const LangOverlayContext = createContext(null);

export function LangOverlayProvider({ children }) {
  const [activeLang, setActiveLang] = useState(null);
  const timerRef = useRef(null);

  const triggerSwitch = (targetLang, doSwitch) => {
    clearTimeout(timerRef.current);
    setActiveLang(targetLang);

    // через 0.5с — меняем язык
    timerRef.current = setTimeout(() => {
      doSwitch();
      // через ещё 1.5с — скрываем оверлей
      timerRef.current = setTimeout(() => setActiveLang(null), 1500);
    }, 500);
  };

  return (
    <LangOverlayContext.Provider value={{ activeLang, triggerSwitch }}>
      {children}
    </LangOverlayContext.Provider>
  );
}

export const useLangOverlay = () => useContext(LangOverlayContext);
